import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { isArray } from 'lodash';

import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';

import postTalkingPoint from 'Api/brief-live/postTalkingPoint';
import upsertTalkingPointPayload from './model/request/upsertTalkingPointPayload';

import { talkingPointUpsertText } from 'Const/brief-live/view';

const usePostTalkingPoint = () => {
  const queryClient = useQueryClient();
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast, onResetToast } = useToast();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async ({ formData, isPublished = false }) => {
      onShowLoader({ variant: 'loader-primary' });

      const payload = upsertTalkingPointPayload(formData, isPublished);

      return await postTalkingPoint({ payload });
    },
    onSuccess: () => {
      onResetToast();
      queryClient.invalidateQueries({ queryKey: ['talking-point-list'] });

      onOpenToast({
        status: 'success',
        description: talkingPointUpsertText?.create?.successDescription,
        duration: 5,
        alwaysShow: false,
      });
      navigate('/brief-live?tab=talkingPoint');
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data?.errors)
        ? error?.response?.data?.errors[0]?.message
        : talkingPointUpsertText?.create?.errorDescription;
      onResetToast();

      onOpenToast({
        status: 'error',
        title: 'Error',
        description: errorMessage,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default usePostTalkingPoint;
